import { useEffect } from 'react'

import { useLanguage } from '@orus.eu/pharaoh'

/**
 * Keeps `<html lang>` equal to the language the UI renders in: `index.html` can only carry the
 * default language. Assistive technology reads the attribute to pick a pronunciation, and
 * translators that ignore `translate="no"` read it to decide whether the page needs translating.
 */
export function DocumentLanguageSync(): null {
  const language = useLanguage()
  useEffect(
    function syncDocumentLanguage() {
      document.documentElement.lang = language
    },
    [language],
  )
  return null
}
